const MONGO_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

export function isMongoProductId(value: string): boolean {
  return MONGO_ID_PATTERN.test(value);
}

export type ProductStoreLink = {
  _id: string;
  stableSlug?: string | null;
};

export type ProductStorePathOptions = {
  /**
   * Use Mongo _id so a specific version opens (admins managing hidden /
   * non-latest family members). Family slug always resolves to latest visible.
   */
  exactVersion?: boolean;
};

/** Customer-facing store path: stable slug when a product family is set, else Mongo _id. */
export function getProductStorePath(
  product: ProductStoreLink,
  options?: ProductStorePathOptions,
): string {
  if (!options?.exactVersion && product.stableSlug) {
    return `/products/${product.stableSlug}`;
  }
  return `/products/${product._id}`;
}
